import { Field, Formik } from "formik";
import { useState } from "react"
import { Button, Col, Form, Image, Modal, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next"
import * as Yup from 'yup';
import Put from "../../api/Put";
import { DOCTOR_UPDATE } from "../../api/Routes";
import LoadingList from "../../loader/LoadingList";
import iconRecheck from '../../img/icons/recheck.svg'
import PhoneInput from 'react-phone-input-2'
import es from 'react-phone-input-2/lang/es.json'
import 'react-phone-input-2/lib/style.css'
import { MdEdit } from "react-icons/md";
import ComponentModalErrorSever from "../ComponentModalErrorSever";

function FormPerfilDoctor({ t, doctorInfo, auth, setDoctorInfo }) {
    // console.log(doctorInfo)
    const [edit, setEdit] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    const [loading, setLoading] = useState(false)
    const [phone, setPhone] = useState(doctorInfo?.phone)

    const [errorServer, setErrorServer] = useState(null)
    const [showModalServer, setShowModalServer] = useState(false)
    const handleCloseModalServer = () => {
        setShowModalServer(false)
    }

    const [initialValues, setInitialValues] = useState({
        id: doctorInfo.id,
        name: doctorInfo.name,
        lastName: doctorInfo.lastName,
        phone: doctorInfo.phone,
        email: doctorInfo.email,
        biography: doctorInfo.biography,
        address: doctorInfo.address ? doctorInfo.address : ''
    })

    const shemaValidate = Yup.object().shape({
        name: Yup.string()
            .required(t('Camporequerido')),
        lastName: Yup.string()
            .required(t('Camporequerido')),
        phone: Yup.string()
            .required(t('Camporequerido'))
    });

    const handleCloseSuccess = () => setShowSuccess(false);

    return (
        <>
            <Formik
                initialValues={initialValues}
                validationSchema={shemaValidate}
                onSubmit={(values, { setSubmitting, setFieldValue }) => {
                    setLoading(true)
                    //setSubmiting(true)    
                    let d = {
                        id: values.id,
                        email: values.email,
                        name: values.name,
                        lastName: values.lastName,
                        phone: values.phone,
                        address: values.address,
                        active: true
                    }


                    Put({ url: DOCTOR_UPDATE, data: d, access_token: auth.data.access_token, header: true })
                        .then(response => {
                            setDoctorInfo(prev => ({
                                ...prev,
                                name: response.data.data.name,
                                lastName: response.data.data.lastName,
                                phone: response.data.data.phone,
                                email: response.data.data.email,
                                professional_cedula: response.data.professional_cedula,
                                address: response.data.address ? response.data.address : '',
                            }))
                            setLoading(false)
                            setEdit(false)
                            setShowSuccess(true)
                            //setUsuario(response.data)                     
                        })
                        .catch(error => {
                            setLoading(false)
                            setShowModalServer(true)
                            if (error.response) {
                                setErrorServer(error.response)
                            }
                        })
                }}
            >{({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
                resetForm,
                setFieldError
            }) => (
                <Form onSubmit={handleSubmit} className='p-3'>
                    {console.log('DoctorInfo: ', doctorInfo)}
                    {loading && <LoadingList texto="Actualizando datos" />}
                    <Modal show={showSuccess} onHide={handleCloseSuccess} centered className="border-0">
                        <Modal.Body className="p-0">
                            <div className="text-center position-relative overflow-hidden h-100p">
                                <Image src={iconRecheck} fluid className="img-recheck" />
                                <h5 className="mb-0 text-app-success">{t('solicitud_exitosa')}</h5>
                            </div>
                        </Modal.Body>
                    </Modal>
                    <input type="hidden" name="id" value={values.id} />
                    <Row>
                        <Col xs="6" md="4" className="mb-3">
                            <label className="mb-0 d-block">{t('Nombre')}</label>
                            {
                                edit ? <Field
                                    type="text"
                                    className={`w-100 input-editable ${errors.name && 'error'}`}
                                    name="name"
                                /> :
                                    <div className="text-secondary">{values.name}</div>
                            }

                        </Col>
                        <Col xs="6" md="4" className="mb-3">
                            <label className="mb-0 d-block">{t('Apellidos')}</label>
                            {
                                edit ? <Field
                                    type="text"
                                    className={`w-100 input-editable ${errors.name && 'error'}`}
                                    name="lastName"
                                /> :
                                    <div className="text-secondary">{values.lastName}</div>
                            }
                        </Col>
                        <Col xs="6" md="4" className="mb-3">
                            <label className="mb-0 d-block">{t('Telefono')}</label>
                            {
                                edit ?
                                    <PhoneInput
                                        inputClass={`input-editable ${errors.phone && 'error'} w-100`}
                                        country={'mx'}
                                        countryCodeEditable={false}
                                        enableSearch={true}
                                        preferredCountries={['mx', 'co']}
                                        disableSearchIcon={true}
                                        localization={es}
                                        value={phone}
                                        onChange={(phone, country, e, formattedValue) => {
                                            setPhone(phone)
                                            setFieldValue('phone', phone, false)
                                            let validNumber = (country.format.match(/\./g)).length
                                            if (phone.length !== validNumber) {
                                                setFieldError('phone', 'Campo inválido')
                                            } else if (phone.length === validNumber) {
                                                setFieldValue('phone', phone, true)
                                            }
                                        }}
                                    /> :
                                    <div className="text-secondary">{values.phone}</div>
                            }
                        </Col>
                        <Col xs="6" md="4" className="mb-3">
                            <label className="mb-0 d-block">{t('Correoelectronico')}</label>
                            <div className="text-secondary">{values.email}</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12" md="12" className="mb-3">
                            <label className="mb-0 d-block">Dirección</label>
                            {
                                edit ? <Field
                                    type="text"
                                    className={`w-100 input-editable ${errors.address && 'error'}`}
                                    name="address"
                                /> :
                                    <div className="text-secondary">{values.address}</div>
                            }
                        </Col>
                    </Row>
                    <Row className="justify-content-end mt-5">
                        {
                            edit ?
                                <Col xs="12" md="12" className="text-right">
                                    <span className="btn btn-link cancel-buttom d-inline" type="buttom" onClick={e => {
                                        setEdit(false)
                                        resetForm({
                                            values: {
                                                id: doctorInfo.id,
                                                name: doctorInfo.name,
                                                phone: doctorInfo.phone,
                                                email: doctorInfo.email,
                                                professional_cedula: doctorInfo.professional_cedula,
                                                biography: doctorInfo.biography,
                                                lastName: doctorInfo.lastName,
                                                address: doctorInfo.address ? doctorInfo.address : ''
                                            }
                                        })
                                    }}>Cancelar</span>
                                    <Button variant="outline-success" className="ok-buttom" type="submit">{t('guardar')}</Button>
                                </Col> :
                                <Col xs="7" md="3" className="align-self-end">
                                    <span className="btn btn-outline-info info-buttom" type="buttom" onClick={e => setEdit(true)}><MdEdit />{t('editar')}</span>
                                </Col>
                        }
                    </Row>

                </Form>
            )}
            </Formik>
            <ComponentModalErrorSever
                show={showModalServer}
                handleClose={handleCloseModalServer}
                error={errorServer}
            />
        </>
    )
}

export default withTranslation()(FormPerfilDoctor);